const baseURL = import.meta.env.VITE_API_URL;

// eslint-disable-next-line import/prefer-default-export
export { baseURL };
